// extracted by mini-css-extract-plugin
export var compactFilters = "_dw-4";
export var detailImage = "_dw-1";
export var dropdownContainer = "_dw-2";
export var imageContainer = "_dw-0";
export var selectedCard = "_dw-3";